document.addEventListener("DOMContentLoaded", () => {

  const galleries = document.querySelectorAll("media-gallery");

  galleries.forEach((gallery) => {

    const thumbnails = gallery.querySelectorAll(".thumbnail");
    const mediaItems = gallery.querySelectorAll(".product__media-item");

    if (!thumbnails.length || !mediaItems.length) return;

    // Highlight active thumbnail
    function setActive(index) {
      thumbnails.forEach((thumb) => thumb.classList.remove("is-active"));

      if (thumbnails[index]) {
        thumbnails[index].classList.add("is-active");

        thumbnails[index].scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest"
        });
      }
    }

    // Thumbnail click
    thumbnails.forEach((thumb, index) => {

      thumb.addEventListener("click", () => {

        setTimeout(() => {
          setActive(index);
        }, 50);

      });

    });

    // Initial active state
    const current = gallery.querySelector(".thumbnail[aria-current='true']");

    if (current) {
      const index = [...thumbnails].indexOf(current);
      if (index >= 0) setActive(index);
    }

    // Watch Shopify gallery changes
    const observer = new MutationObserver(() => {

      const current = gallery.querySelector(".thumbnail[aria-current='true']");

      if (!current) return;

      const index = [...thumbnails].indexOf(current);

      if (index >= 0) setActive(index);

    });

    observer.observe(gallery, {
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-current"]
    });

  });

});